// @ts-nocheck
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

export type SetTrackingInfoReadyParameter = {
    ready: boolean;
};

type HandlerType = ApiHandler<SetTrackingInfoReadyParameter>;

export const DispatchCompleteSetTrackingReady: HandlerType = props => {
    const { dispatch } = props;
    dispatch({
        type: "Store/Pages/OrderDetails/SetTrackingInfoReady",
        ready: props.parameter.ready,
    });
};

export const chain = [DispatchCompleteSetTrackingReady];

const setTrackingInfoReady = createHandlerChainRunner(chain, "SetTrackingInfoReady");
export default setTrackingInfoReady;
